import { isMobile } from "@common/utils/utils";
import { CountUp } from "countup.js";
import { Swiper } from "swiper11";
import { SwiperOptions } from "swiper11/types/swiper-options";

export function countUp(target: string = ".counter", opts: any = {}) {
  const List = $(target);
  if (!List.length) return;
  const defaults = {
    duration: 0.8,
    useEasing: false,
    enableScrollSpy: true,
    scrollSpyDelay: 0,
    ...opts,
  };
  List.each((_i, item) => {
    const Num = Number($(item).text());
    if (!Num || typeof Num !== "number") return;
    if(item.getAttribute("data-separator")){
      new CountUp(item, Num, Object.assign({useGrouping: false},defaults));
    }else{
      new CountUp(item, Num, defaults);
    }
    
  });
}
export function lazyLoad() {
  const lazyImages = $("body").find("img[yige-src],*[yige-background]");
  lazyImages.each((_i, el) => {
    const SRC = $(el).attr("yige-src");
    const BACKGROUND = $(el).attr("yige-background");
    if (SRC) {
      $(el).attr("src", SRC);
    }
    if (BACKGROUND) {
      $(el).css("background-image", `url(${BACKGROUND})`);
    }
  });
}
export function ImportBundle(options: BundleImporter.BundleOptions, src: BundleImporter.ScriptSrc[] | string[]) {
  const PATH = window.location.pathname;
  const INDEX_FLAG = /index.html$/g.test(PATH);
  if (!options.isIndex && !options.onlyIndex && (PATH == "/" || INDEX_FLAG)) return;
  if (options.onlyIndex && PATH !== "/" && !INDEX_FLAG) return;
  if (options.isMobile && document.body.clientWidth < 768) return;

  let _count: number = src.length || 0;
  let _scritpLoaded: number = 0;
  let _resolve: (value: boolean) => void = () => {};
  const documentFragment: DocumentFragment = document.createDocumentFragment();

  // 生成css标签
  function createCssLink(linkSrc: string[]) {
    linkSrc.forEach((link) => {
      if (typeof link !== "string") return;
      const L = document.createElement("link");
      L.rel = "stylesheet";
      L.href = link;
      documentFragment.appendChild(L);
      _scritpLoaded++;
      checkAllScriptsLoaded();
    });
  }
  // 生成script标签
  function createScriptSrc(linkSrc: BundleImporter.ScriptSrc[]) {
    const onload = (item: BundleImporter.ScriptSrc) => {
      _scritpLoaded++;
      if (item.fn && typeof item.fn == "function") {
        item.fn();
      }
      checkAllScriptsLoaded();
    };

    linkSrc.forEach((item) => {
      if (!item || (!item.src && typeof item !== "object")) return;
      if (item.isMobile && document.body.clientWidth < 768) {
        _count--;
        return;
      }
      const script = document.createElement("script");
      script.src = item.src;
      script.defer = item?.defer ?? false;
      script.async = item?.async ?? false;
      script.onload = () => onload(item);
      documentFragment.appendChild(script);
    });
  }
  function checkAllScriptsLoaded() {
    if (_scritpLoaded === _count) {
      if (options.callback && typeof options.callback == "function") {
        options.callback();
      }
      _resolve(true);
    }
  }
  // 导入
  function Import() {
    return new Promise<boolean>((resolve, _reject) => {
      _resolve = resolve;
      const container = document.getElementsByTagName("head")[0];
      const Pos = container.querySelector('link[rel="stylesheet"]');
      if (options.type === "css") {
        createCssLink(src as string[]);
      } else {
        createScriptSrc(src as BundleImporter.ScriptSrc[]);
      }
      if (options.position && options.position === "end") {
        container.appendChild(documentFragment);
      } else {
        container.insertBefore(documentFragment, Pos);
      }
    });
  }
  return Import();
}

interface CreatedThumbsOpts {
  swiperOptions: SwiperOptions;
  cloneTarget?: string;
}

/**
 * 创建并初始化缩略图Swiper的函数。
 * 
 * 该函数根据主Swiper实例中的幻灯片生成缩略图，并将缩略图与主Swiper进行联动。
 * 
 * @function createdThumbs
 * @param {Swiper} swiper - 主Swiper实例，用于同步缩略图的主视图Swiper。
 * @param {string} thumbsSelect - 缩略图Swiper的容器选择器，用于定位缩略图的HTML元素。
 * @param {SwiperOptions} [opts] - 可选的Swiper配置对象，用于定制缩略图Swiper的行为和外观。
 * 
 * @returns {void}
 */
export function createdThumbs(swiper: Swiper, thumbsSelect: string, opts?: CreatedThumbsOpts) {
  const slideList = $(swiper.el).find(".swiper-slide");
  const container = $(thumbsSelect); // 缩略图Swiper
  const wrapper = $("<div class='swiper-wrapper'></div>");
  if (!slideList.length || !container.length) return;
  const tempFragment = document.createDocumentFragment();
  slideList.each((_i, item) => {
    const target = $(item).find(opts?.cloneTarget || ".img-box");
    const clone = $(target).clone().removeClass("zoomSl")[0];
    const slide = $(`<div class='swiper-slide'></div>`);
    slide.append(clone);
    tempFragment.appendChild(slide[0]); // Append the slide to the fragment
  });

  wrapper.append(tempFragment);
  container.append(wrapper);
  const THUMBS = new Swiper(container[0], opts?.swiperOptions ?? {});
  swiper.thumbs.swiper = THUMBS;
  swiper.on("afterInit", (S) => {
    S.thumbs.init();
    S.thumbs.update(true);
    S.update();
  });
  swiper.on("slideChange", (S) => {
    const thumbs = S.thumbs.swiper;
    const currentIdx = thumbs.params.loop ? S.activeIndex : S.realIndex;
    thumbs.slideTo(currentIdx, 500, false);
  });
}

/**
 * 头部导航栏Fixed
 * @function fixedsHeader
 * @param {string} id
 * @param {string} className "header-fixeds_1"
 * @param {number} H
 **/
export function fixedsHeader(id: string, className = "header-fixeds_1", H?: number) {
  const header = $(`header.${id}`)!;
  const h = header.height()!;
  const coverHeight = () => {
    let temp_h = 0;
    header.find(".sub-wrapper").each((_i, item) => {
      if ($(item).outerHeight()! > temp_h) {
        temp_h = $(item).outerHeight()!;
      }
    });
    header.css("--cover-height", temp_h + "px");
  };
  if (isMobile(1024)) {
    $(header)
      .find(".trigger")
      .on("click", function () {
        $(this).toggleClass("trigger_active");
        $(this).siblings(".content_mt_ul").slideToggle(300);
      });
    $(header)
      .find(".mobile_nav .nav_bg")
      .on("click", function () {
        $("html").css("overflow-y", "unset");
        $(".mobile_nav .mobile_nav_content").removeClass("nav_show");
      });
    $(header)
      .find(".mobile_nav .cus-bars")
      .on("click", function () {
        $("html").css("overflow-y", "hidden");
        $(".mobile_nav .mobile_nav_content").addClass("nav_show");
      });
  } else {
    coverHeight();
    $(window).on("scroll", () => {
      if ($(window).scrollTop()! > (H ?? h)) {
        header.addClass(className);
      } else if ($(window).scrollTop()! === 0) {
        header.removeClass(className);
      }
    });
    header.find(".pc-header .header-nav").on("mouseenter", () => {
      header.addClass("show");
      coverHeight();
    });
    header.find(".pc-header .header-nav").on("mouseleave", () => {
      header.removeClass("show");
    });
  }
}

/**
 * 防抖函数
 * @param {Function} fn
 * @param {number} delay
 * @returns {() => void}
 */
export function debounce(fn: Function, delay: number) {
  // let timer: NodeJS.Timer;
  let timer: any;
  return function (...args: any) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(
      () => {
        typeof fn === "function" && fn.apply(null, args);
        clearTimeout(timer);
      },
      delay > 0 ? delay : 100
    );
  };
}
